
// CadastrarFornecedor.js

import React, { useState, useEffect } from 'react';
import NameField from '../components/NameField';
import CodigoField from '../components/CodigoField';
import DatepickerField from '../components/DatepickerField';
import EmailField from '../components/EmailField';
import PhoneField from '../components/PhoneField';
import CnpjField from '../components/CnpjField';
import CpfField from '../components/CpfField';
import InscEstField from '../components/InscEstField';
import InscMunField from '../components/InscMunField';
import CepField from '../components/CepField';
import NumeroField from '../components/NumeroField';
import ComplementoField from '../components/ComplementoField';
import CurrencyField from '../components/CurrencyField';
import FormaPagamentoSelect from './FormaPagamentoSelect';
import CondPagamentoSelect from './CondPagamentoSelect';
import Box from '@mui/material/Box';
//import Axios from 'axios';
import api from '../config/axiosConfig';

function CadastrarFornecedor({ handleFornecedorSalvo, handleCancelar }) {
  const [formData, setFormData] = useState({
    nomefor: '',
    codfor: '',
    dtcadastro: '',
    email: '',
    fone: '',
    celular: '',
    cnpjfor: '',
    cpfcli: '',
    inscricaoest: '',
    inscricaomun: '',
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    uf: '',
    credito: '0,00',
    formapag: '',
    condpag: '',
  });

  const paymentMethods = ['Em Espécie', 'PIX', 'Cartão', 'Boleto', 'Depósito', 'Transferência'];
  const conditionMethods = ['À Vista', '15 dias', '30 dias', '60 dias', '30-60 dias', '30-60-90 dias'];

  const [formErrors, setFormErrors] = useState({
    nomefor: '',
    codfor: '',
    cnpjfor: '',
    email: '',
  });

  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    console.log('CadastrarFornecedor montado');
  }, []); // só será executado uma vez.

  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };
  
  const handleAddressChange = (address) => {
    setFormData((prevData) => ({
      ...prevData,
      logradouro: address.logradouro,
      bairro: address.bairro,
      cidade: address.cidade,
      uf: address.uf,
    }));
  };

  const verificarFornecedorExistente = async (codfor, nomefor, cnpjfor) => {
    try {
      const response = await api.get('/buscarfornecedor', {
        params: { codfor, nomefor, cnpjfor }
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao verificar fornecedor existente no Cadastro:', error);
      return [];
    }
  };

  // Função para obter a data atual no formato yyyy-mm-dd
  const getDataAtualISO = () => {
    const data = new Date();
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
    const ano = data.getFullYear();
    return `${ano}-${mes}-${dia}`;
  };

  const handleSaveClick = async () => {
    if (isSaving) {
      return;
    }

    if (formData.id) {
      console.log('Fornecedor já Existe, id:', formData.id);
      return;
    }

    const mandatoryFields = ['nomefor', 'codfor', 'cnpjfor', 'email'];
    const hasErrors = mandatoryFields.some(field => formData[field].trim() === '');

    if (hasErrors) {
      alert('Os Campos: Código, Nome, E-mail e CNPJ são obrigatórios.');
      return;
    }

    // Se a data de cadastro estiver vazia, define a data atual
    if (!formData.dtcadastro.trim()) {
      formData.dtcadastro = getDataAtualISO();
    }

    setIsSaving(true);
    try {
      const errosExistentes = await verificarFornecedorExistente(formData.codfor, formData.nomefor, formData.cnpjfor);

      if (errosExistentes.length > 0) {
        const novoFormErrors = { codfor: '', nomefor: '', cnpjfor: '' };
        errosExistentes.forEach(erro => {
          novoFormErrors[erro.campo] = erro.mensagem;
        });
        setFormErrors(novoFormErrors);
        setIsSaving(false);
      // Exibir o alerta quando fornecedor já existe
        window.alert('Atenção... Código, Nome ou CNPJ do Fornecedor já existem no Cadastro.');
        return;
      } else {
        console.log('Enviando dados do fornecedor:', formData);
        const response = await api.post('/cadastrarfornecedor', formData);
        console.log('Fornecedor salvo com sucesso:', response.data);
        window.alert(`Fornecedor: ${formData.nomefor} Cadastrado com Sucesso.`);
        handleFornecedorSalvo(response.data);
        setFormData(prevData => ({ ...prevData, id: response.data.id }));
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 409) {
        window.alert('Atenção... Código, Nome ou CNPJ do Fornecedor já existem no Cadastro.');
        } else {
          alert(`Erro ao salvar fornecedor: ${error.response.data.mensagem}`);
        }
      } else {
        alert('Erro ao salvar fornecedor. Por favor, tente novamente.');
      }
    } finally {
      setIsSaving(false);
    }
  };

    
  return (
    <div
      style={{
        minHeight: 'calc(100vh - 20px)',
        maxWidth: '900px',
        paddingTop: '0px',
        marginLeft: '0px',
        margin: '0 auto', // Centralizando o container
        textAlign: 'center', // Alinhamento central
      }}
    >

      <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '20px' }}>
        {Object.keys(formErrors).map((key, index) => (
          <p key={index} style={{ color: 'red', marginBottom: '0px'}}>{formErrors[key]}</p>
        ))}

      <div style={{ marginBottom: '10px', marginTop: '10px'}}>
        <h3>Digite os Dados do Fornecedor</h3>
      </div>

      <div style={{ textAlign: 'left', marginLeft: '20px' }}>
        <div style={{ display: 'flex', marginBottom: '25px' }}>
          <div style={{ marginRight: '20px', width: '520px', height: '30px' }}>
            <label style={{ display: 'block', width: '520px' }}>Nome:</label>
            <NameField value={formData.nomefor} onChange={value => handleChange('nomefor', value)} />
          </div>
          <div style={{ width: '100px', marginRight: '20px', height: '30px' }}>
            <label style={{ display: 'block', width: '100px', marginRight: '20px' }}>Código:</label>
              <CodigoField value={formData.codfor} onChange={value => handleChange('codfor', value)} />
          </div>
          <div style={{ width: '150px', height: '28px' }}>
            <label style={{ display: 'block', width: '150px', marginBottom: '0px' }}>Data de Cadastro:</label>
            <DatepickerField value={formData.dtcadastro} onChange={value => handleChange('dtcadastro', value)} />
          </div>
        </div>

        <div style={{ display: 'flex', marginBottom: '25px' }}>
          <div style={{ width: '420px', height: '30px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '410px' }}>E-mail:</label>
            <EmailField value={formData.email} onChange={value => handleChange('email', value)} />
          </div>
          <div style={{ width: '200px', height: '30px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>Telefone:</label>
            <PhoneField value={formData.fone} onChange={value => handleChange('fone', value)} />
          </div>
          <div style={{ width: '200px', height: '30px' }}>
            <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>Celular:</label>
            <PhoneField value={formData.celular} onChange={value => handleChange('celular', value)} />
          </div>
        </div>

        <div style={{ display: 'flex', marginBottom: '25px' }}>
          <div style={{ width: '200px', marginRight: '20px', height: '30px' }}>
            <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>CNPJ:</label>
            <CnpjField value={formData.cnpjfor} onChange={value => handleChange('cnpjfor', value)} />
          </div>
          <div style={{ width: '200px', marginRight: '20px', height: '30px' }}>
            <label style={{ display: 'block', width: '200px', marginBottom: '0px', marginRight: '20px' }}>CPF:</label>
            <CpfField value={formData.cpfcli} onChange={value => handleChange('cpfcli', value)} />
          </div>
          <div style={{ width: '200px', marginRight: '20px', height: '30px' }}>
            <label style={{ display: 'block', width: '200px', marginBottom: '0px', marginRight: '20px' }}>Inscrição Estadual:</label>
            <InscEstField value={formData.inscricaoest} onChange={value => handleChange('inscricaoest', value)} />
          </div>
          <div style={{ width: '200px', height: '30px' }}>
            <label style={{ display: 'block', width: '200px', marginBottom: '0px' }}>Inscrição Municipal:</label>
            <InscMunField value={formData.inscricaomun} onChange={value => handleChange('inscricaomun', value)} />
          </div>
        </div>
          
        <div style={{ display: 'flex', marginBottom: '0px', marginTop: '0px' }}>
          <div style={{ width: '120px', marginRight: '20px', marginBottom: '0px',marginTop: '0px' }}>
            <CepField 
            value={formData.cep} 
            onChange={value => handleChange('cep', value)} 
            onAddressChange={handleAddressChange}/>
          </div>

          <div style={{ width: '100px', marginRight: '20px', marginLeft: '440px' }}>
            <label style={{ display: 'block', width: '100px', marginRight: '20px' }}>Número:</label>
            <NumeroField value={formData.numero} onChange={value => handleChange('numero', value)} />
            </div>
            
         <div style={{ width: '160px' }}>
            <label style={{ display: 'block', width: '160px' }}>Complemento:</label>
            <ComplementoField value={formData.complemento} onChange={value => handleChange('complemento', value)} />
          </div>
        </div>

          
      <div style={{ display: 'flex', marginBottom: '25px' }}>
        <div style={{ width: '120px', marginRight: '0px', marginBottom: '0px' }}>
          <label style={{ display: 'block', width: '120px', marginBottom: '0px' }}>Crédito:</label>
          <CurrencyField value={formData.credito} onChange={value => handleChange('credito', value)} />
        </div>
          
        <div style={{ width: '200px', marginLeft: '0px', marginBottom: '0px' }}>
         <FormaPagamentoSelect 
          paymentMethods={paymentMethods} 
          selectedMethod={formData.formapag} 
          onChange={(value) => handleChange('formapag', value)} 
        />
        </div>

        <div style={{ width: '230px', marginLeft: '20px', marginBottom: '0px' }}>
         <CondPagamentoSelect 
          conditionMethods={conditionMethods} 
          selectedMethod={formData.condpag} 
          onChange={(value) => handleChange('condpag', value)} 
        />
        </div>
            
      </div>

          <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0px' }}>
            <button  type="button" className='btn-menu' onClick={handleSaveClick} style={{ width: '100px', height: '30px', padding: '3px 5px', marginRight: '50px', color: 'inherit' }}>
              {isSaving ? 'Salvando...' : 'Salvar'}
              </button>
              
            <button  type="button" className='btn-menu' onClick={handleCancelar} style={{ width: '100px', height: '30px', padding: '3px 5px', color: 'inherit' }}>
              Cancelar
            </button>
            </div>
          </Box>

        </div>
        </div>
    </div>
  );
}

export default CadastrarFornecedor;

